/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, KeyboardAvoidingView } from 'react-native';
import * as Yup from 'yup';

import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';
import {
  SociollaInput,
  SociollaForm,
  SociollaSubmitButton,
} from '@components/sociolla/form';
import SociollaText from '@components/sociolla/SociollaText';
import ModalHalf from '@components/modal/ModalHalf';

import Colors from '@global/colors';
import { isWeb, isIos } from '@global/screens';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

const ModalReject = (props) => {
  const buttonWidth = isWeb ? 300 : '100%';
  const handleSubmit = (data) => props.onSubmit(data.reason);

  return (
    <KeyboardAvoidingView behavior={isIos ? 'padding' : undefined}>
      <ModalHalf
        testID={props.testID}
        visible={props.show}
        fullPage={isWeb ? true : false}
        animationType={isWeb ? 'fade' : 'slide'}
        maxWidth={isWeb ? 450 : '100%'}
        onClose={props.onClose}
        title={props.title ? props.title : 'Reject Customer Registration'}>
        <SociollaForm
          initialValues={{ reason: '' }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            reason: Yup.string().required('Reason is required').label('Reason'),
          })}>
          <View style={{ width: '100%', paddingHorizontal: 16 }}>
            <SociollaInput
              testID="modal-reject-reason-input"
              label="Enter reason for rejection:"
              multiline={true}
              numberOfLines={4}
              name="reason"
            />
            <View
              style={[
                isWeb
                  ? { alignItems: 'center', marginTop: 24 }
                  : {
                      ...buttonFloating,
                      marginTop: 20,
                      padding: 0,
                      paddingTop: 15,
                      justifyContent: 'center',
                      position: 'relative',
                      elevation: 0,
                    },
                { width: '100%', bottom: 0 },
              ]}>
              <SociollaSubmitButton
                testID="modal-reject-submit-btn"
                buttonStyle={{
                  ...buttonRounded,
                  width: buttonWidth,
                  ...(isWeb ? { marginHorizontal: 10 } : {}),
                }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    Submit
                  </SociollaText>
                }
              />
            </View>
          </View>
        </SociollaForm>
      </ModalHalf>
    </KeyboardAvoidingView>
  );
};

ModalReject.propTypes = propTypes;

export default ModalReject;
